import React from "react";
export var ToastContext = React.createContext({
    addToast: function (toast) {
        throw new Error('You cannot add a toast from a component that is not a desendant of the ToastProvider');
    }
});
